import { forwardRef } from 'react';
import type { FormProps } from '@/formbuilder/FormBuilder.page';
import { FormBuilder } from '@/formbuilder/FormBuilder.page';

interface SimpleSaveFormBuilderProps extends FormProps {
  /** the function that is called when the form is submitted */
  submitFn: (values: any) => void;
  extraClassNames?: string;
}

/**
 * SimpleSaveFormBuilder generates forms based on the provided form definition Array.
 * SimpleSaveFormBuilder is NOT TO BE USED for tools - use ToolFormBuilder for tools. SimpleSaveFormBuilder should
 * be used for forms that only display a save/cancel button, and do not need tool specific tracking.
 **/
export const SimpleSaveFormBuilder: React.FunctionComponent<SimpleSaveFormBuilderProps> = forwardRef(
  function SimpleSaveFormBuilder(props, ref) {
    return <FormBuilder {...props} ref={ref} saveAndCancel={true} extraClassNamesUnwrapped={props.extraClassNames} />;
  },
);
